import { render } from "./OrderMoney.vue?vue&type=template&id=7f66b15c&scoped=true"
import script from "./OrderMoney.vue?vue&type=script&lang=js"
export * from "./OrderMoney.vue?vue&type=script&lang=js"

import "./OrderMoney.vue?vue&type=style&index=0&id=7f66b15c&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f66b15c"]])

export default __exports__